import { Box, makeStyles, Grid, Chip, Container, Fab, Button } from '@material-ui/core';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { getTipMatrix } from 'services/ratings.service';
import { isEmpty } from 'lodash';
import ReactJson from 'react-json-view';
import { localizeCurrency } from '../../../../util/localizeFormat';
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles((theme) => {
  return {
    ratingBoxRoot: {

    },
    fabContainer: {
      margin: theme.spacing(1),
    }
  }
})
const TipMatrix = ({ tipMatrix = [], tipValue, onSelect = () => { } }) => {
  const classes = useStyles()
  const trackEvent = useTrackEvent()

  return (
    <Container maxWidth="sm" className={classes.ratingBoxRoot}>
      {tipMatrix.map((tip, idx) => {
        return (
          <Button size="small"
            variant={tipValue === tip ? 'contained' : 'outlined'}
            color={tipValue === tip ? 'primary' : 'default'}
            className={classes.fabContainer}
            onClick={() => {
              trackEvent('Rating - tip matrix - select', { tip })
              onSelect(tip)
            }}
            key={idx}>{localizeCurrency(tip)}</Button>

        )


      })}
    </Container>
  )
}

export { TipMatrix }